import React, { useState, useEffect } from 'react';

const config = {
  API_BASE_URL: "http://114.29.239.77:7057/"
};

const Oncall = ({ setCurrentView }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [showAddEventForm, setShowAddEventForm] = useState(false);
  

  const [newEvent, setNewEvent] = useState({
    title: '',
    category: '',
    date: '',
    activity: '',
    contact: '',
    name: ''
  });
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const openModal = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}Events`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setEvents(data);
      } catch (err) {
        setError('Failed to fetch events');
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  const filteredEvents = events.filter((event) => {
    const matchesSearch =
      event.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      event.category.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus =
      statusFilter === 'All' ||
      (statusFilter === 'Completed' && event.done) ||
      (statusFilter === 'Pending' && !event.done);
    return matchesSearch && matchesStatus;
  });

  const handleDelete = async (title) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}Events/${title}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Failed to delete event');
      setEvents(events.filter((event) => event.title !== title));
    } catch (error) {
      alert('Failed to delete the event');
    }
  };

  const handleAddEvent = async () => {
    if (!newEvent.title || !newEvent.date) {
      alert('Title and Date are required!');
      return;
    }
    try {
      const encodedTitle = encodeURIComponent(newEvent.title);
      const response = await fetch(`${config.API_BASE_URL}Events/activity/${encodedTitle}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newEvent),
      });
      if (!response.ok) throw new Error('Failed to add new event');
      const addedEvent = await response.json();
      setEvents((prev) => [...prev, addedEvent]);
      setShowAddEventForm(false);
      setNewEvent({ title: '', category: '', date: '', activity: '', contact: '', name: '' });
    } catch (error) {
      alert('Failed to add the event: ' + error.message);
    }
  };

  const totalPages = Math.ceil(filteredEvents.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentEvents = filteredEvents.slice(startIndex, startIndex + itemsPerPage);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewEvent((prev) => ({ ...prev, [name]: value }));
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
    setShowAddEventForm(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-950">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-gray-400 text-sm tracking-widest uppercase">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-950">
        <div className="flex items-center gap-3 bg-red-950/50 border border-red-800 text-red-400 px-6 py-4 rounded-xl">
          <i className="fas fa-exclamation-triangle"></i>
          <span>{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 p-6 md:p-8 font-sans">

      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-1 h-8 bg-blue-500 rounded-full"></div>
          <h2 className="text-3xl font-bold tracking-tight text-white">On-Call List</h2>
        </div>
        <p className="text-gray-500 text-sm pl-4 ml-1">Manage and track on-call events</p>
      </div>

      {/* Search + Filter Row */}
      <div className="flex flex-wrap gap-3 mb-6">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="bg-gray-900 border border-gray-700 text-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 cursor-pointer transition-colors"
        >
          <option value="All">All Status</option>
          <option value="Completed">Completed</option>
          <option value="Pending">Pending</option>
        </select>

        <div className="flex-1 relative min-w-48">
          <i className="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none"></i>
          <input
            type="text"
            placeholder="Search by title or category..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-gray-900 border border-gray-700 text-gray-300 rounded-lg pl-9 pr-4 py-2.5 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 placeholder-gray-600 transition-colors"
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3 mb-6">
        <button
          onClick={() => setShowAddEventForm(true)}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm px-4 py-2.5 rounded-lg transition-all duration-200 active:scale-95 shadow-lg shadow-blue-900/30"
        >
          <i className="fas fa-plus text-xs"></i>
          Add New
        </button>

        <button
          onClick={() => setCurrentView('calendar')}
          className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 border border-gray-700 text-gray-300 hover:text-white font-semibold text-sm px-4 py-2.5 rounded-lg transition-all duration-200 active:scale-95"
        >
          <i className="fas fa-calendar text-xs text-blue-400"></i>
          On-Call Calendar
        </button>
      </div>

      {/* Table */}
      <div className="rounded-xl border border-gray-800 overflow-hidden shadow-2xl">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-900 border-b border-gray-800">
                {['Name', 'Title', 'Category', 'Date', 'Activity', 'Contact', 'Status', 'Actions'].map((h) => (
                  <th
                    key={h}
                    className="text-left text-xs font-semibold text-gray-400 uppercase tracking-wider px-4 py-3 whitespace-nowrap"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800/60">
              {filteredEvents.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-gray-600 py-16">
                    <i className="fas fa-inbox text-3xl mb-3 block"></i>
                    <span className="text-sm">No events found</span>
                  </td>
                </tr>
              ) : (
                currentEvents.map((event) => (
                  <tr
                    key={event.id}
                    onClick={() => openModal(event)}
                    className="bg-gray-950 hover:bg-gray-900 cursor-pointer transition-colors duration-150 group"
                  >
                    <td className="px-4 py-3 font-medium text-gray-200 whitespace-nowrap">{event.name}</td>
                    <td className="px-4 py-3 text-gray-300 whitespace-nowrap">{event.title}</td>
                    <td className="px-4 py-3">
                      <span className="inline-block bg-gray-800 text-gray-400 text-xs px-2.5 py-1 rounded-full border border-gray-700">
                        {event.category}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-gray-400 whitespace-nowrap">
                      {new Date(event.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </td>
                    <td className="px-4 py-3 text-gray-400 max-w-xs truncate">{event.activity}</td>
                    <td className="px-4 py-3 text-gray-400 whitespace-nowrap font-mono text-xs">{event.contact}</td>
                    <td className="px-4 py-3">
                      {event.done ? (
                        <span className="inline-flex items-center gap-1.5 text-emerald-400 text-xs font-medium">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block"></span>
                          Completed
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 text-amber-400 text-xs font-medium">
                          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block animate-pulse"></span>
                          Pending
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={(e) => { e.stopPropagation(); handleDelete(event.title); }}
                        className="text-gray-600 hover:text-red-400 transition-colors duration-150 p-1.5 rounded-lg hover:bg-red-950/40"
                        title="Delete Event"
                      >
                        <i className="fas fa-trash-alt text-sm"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {filteredEvents.length > 0 && (
        <div className="flex items-center justify-between mt-4 px-1">
          <span className="text-xs text-gray-600">
            Showing {startIndex + 1}–{Math.min(startIndex + itemsPerPage, filteredEvents.length)} of {filteredEvents.length} events
          </span>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-900 border border-gray-800 text-gray-400 hover:text-white hover:border-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <span className="text-xs text-gray-500 px-2">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-900 border border-gray-800 text-gray-400 hover:text-white hover:border-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-xs"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      )}

      {/* Add Event Modal */}
      {showAddEventForm && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl w-full max-w-md shadow-2xl">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-800">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-600/20 rounded-lg flex items-center justify-center">
                  <i className="fas fa-plus text-blue-400 text-sm"></i>
                </div>
                <h3 className="font-semibold text-white">Add New Event</h3>
              </div>
              <button onClick={closeModal} className="text-gray-600 hover:text-white transition-colors w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-800">
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="p-6 space-y-3">
              {[
                { name: 'title', placeholder: 'Event Title', icon: 'fa-tag' },
                { name: 'name', placeholder: 'Person Name', icon: 'fa-user' },
                { name: 'category', placeholder: 'Category', icon: 'fa-folder' },
                { name: 'activity', placeholder: 'Activity', icon: 'fa-tasks' },
                { name: 'contact', placeholder: 'Contact Number', icon: 'fa-phone' },
              ].map(({ name, placeholder, icon }) => (
                <div key={name} className="relative">
                  <i className={`fas ${icon} absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 text-sm pointer-events-none`}></i>
                  <input
                    type="text"
                    name={name}
                    placeholder={placeholder}
                    value={newEvent[name]}
                    onChange={handleInputChange}
                    className="w-full bg-gray-950 border border-gray-700 text-gray-200 rounded-lg pl-9 pr-4 py-2.5 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 placeholder-gray-600 transition-colors"
                  />
                </div>
              ))}
              <div className="relative">
                <i className="fas fa-calendar absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 text-sm pointer-events-none"></i>
                <input
                  type="date"
                  name="date"
                  value={newEvent.date}
                  onChange={handleInputChange}
                  className="w-full bg-gray-950 border border-gray-700 text-gray-200 rounded-lg pl-9 pr-4 py-2.5 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
                />
              </div>
            </div>

            <div className="flex gap-3 px-6 pb-6">
              <button
                onClick={handleAddEvent}
                className="flex-1 bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm py-2.5 rounded-lg transition-all duration-200 active:scale-95"
              >
                Add Event
              </button>
              <button
                onClick={closeModal}
                className="flex-1 bg-gray-800 hover:bg-gray-700 text-gray-300 font-semibold text-sm py-2.5 rounded-lg transition-all duration-200 active:scale-95 border border-gray-700"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Event Detail Modal */}
      {isModalOpen && selectedEvent && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl w-full max-w-md shadow-2xl">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-800">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-purple-600/20 rounded-lg flex items-center justify-center">
                  <i className="fas fa-info text-purple-400 text-sm"></i>
                </div>
                <h3 className="font-semibold text-white">Event Details</h3>
              </div>
              <button onClick={closeModal} className="text-gray-600 hover:text-white transition-colors w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-800">
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="p-6 space-y-3">
              {[
                { label: 'Name', value: selectedEvent.name, icon: 'fa-user' },
                { label: 'Title', value: selectedEvent.title, icon: 'fa-tag' },
                { label: 'Category', value: selectedEvent.category, icon: 'fa-folder' },
                {
                  label: 'Date',
                  value: new Intl.DateTimeFormat('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(selectedEvent.date)),
                  icon: 'fa-calendar'
                },
                { label: 'Activity', value: selectedEvent.activity, icon: 'fa-tasks' },
                { label: 'Contact', value: selectedEvent.contact, icon: 'fa-phone' },
              ].map(({ label, value, icon }) => (
                <div key={label} className="flex items-start gap-3 bg-gray-950/50 rounded-lg px-4 py-3 border border-gray-800/50">
                  <i className={`fas ${icon} text-gray-600 text-sm mt-0.5 w-4 flex-shrink-0`}></i>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-600 uppercase tracking-wider mb-0.5">{label}</p>
                    <p className="text-sm text-gray-200 truncate">{value}</p>
                  </div>
                </div>
              ))}

              {/* Status */}
              <div className="flex items-start gap-3 bg-gray-950/50 rounded-lg px-4 py-3 border border-gray-800/50">
                <i className="fas fa-signal text-gray-600 text-sm mt-0.5 w-4 flex-shrink-0"></i>
                <div className="flex-1">
                  <p className="text-xs text-gray-600 uppercase tracking-wider mb-0.5">Status</p>
                  {selectedEvent.done ? (
                    <span className="inline-flex items-center gap-1.5 text-emerald-400 text-sm font-medium">
                      <i className="fas fa-check-circle text-xs"></i>
                      Completed
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 text-amber-400 text-sm font-medium">
                      <i className="fas fa-clock text-xs"></i>
                      Pending
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="px-6 pb-6">
              <button
                onClick={closeModal}
                className="w-full bg-gray-800 hover:bg-gray-700 border border-gray-700 text-gray-300 hover:text-white font-semibold text-sm py-2.5 rounded-lg transition-all duration-200 active:scale-95"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Oncall;